import { useEffect, useState } from "react";
import { Reveal, SectionLabel } from "./ui";

export default function Ablauf({ steps = [], index, appr }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!steps.length) return undefined;
    const id = setInterval(() => {
      setActive((a) => (a + 1) % steps.length);
    }, 1100);
    return () => clearInterval(id);
  }, [steps.length]);

  return (
    <section style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <Reveal><SectionLabel index={index}>Der Ablauf</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)] max-w-2xl">
            Von der Anfrage bis zum <span className="font-medium">dokumentierten Einsatz</span>.
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--mf-line)] border border-[var(--mf-line)]">
          {steps.map((s, i) => {
            const isActive = i === active;
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div
                  data-testid={`ablauf-${i}`}
                  className={`h-full p-8 relative group overflow-hidden transition-colors duration-500 ${isActive ? "bg-white" : "bg-[var(--mf-mist)] hover:bg-white"}`}
                >
                  <div
                    className={`absolute left-0 top-0 h-[3px] bg-[var(--mf-red)] transition-all duration-500 ${isActive ? "w-full" : "w-0 group-hover:w-full"}`}
                  />
                  <div
                    className={`font-head text-5xl font-light tabular-nums transition-colors duration-500 ${isActive ? "text-[var(--mf-red)]" : "text-[var(--mf-line)] group-hover:text-[var(--mf-red)]"}`}
                  >
                    {s.no}
                  </div>
                  <h3 className="font-head font-bold text-[1.125em] mt-4 text-[var(--mf-ink)]">{s.title}</h3>
                  <p className="mt-2 text-[0.875em] leading-relaxed text-[var(--mf-ink-soft)]">{s.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
